import { render, staticRenderFns } from "./shape.vue?vue&type=template&id=680dc8c1&"
import script from "./shape.vue?vue&type=script&lang=js&"
export * from "./shape.vue?vue&type=script&lang=js&"
import style0 from "./shape.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports